import React, { useState } from "react";
import mahindra from "../../../assets/buysell/mahindra.png";
import toyota from "../../../assets/buysell/toyota.png";
import tata from "../../../assets/buysell/tata.png";
import hyundai from "../../../assets/buysell/hyundai.png";
import suzuki from "../../../assets/buysell/suzuki.png";
import ford from "../../../assets/buysell/ford.png";
import honda from "../../../assets/buysell/honda.png";
import renault from "../../../assets/buysell/renault.png";
import kia from "../../../assets/buysell/kia.png";
import w from "../../../assets/buysell/w.png";
import chavrolet from "../../../assets/buysell/chavrolet.png";
import skoda from "../../../assets/buysell/skoda.png";
import nissan from "../../../assets/buysell/nissan.png";
import benz from "../../../assets/buysell/benz.png";
import bmw from "../../../assets/buysell/bmw.png";
import audi from "../../../assets/buysell/audi.png";
import volvo from "../../../assets/buysell/volvo.png";
import jaguar from "../../../assets/buysell/jaguar.png";

const brands = [
  {
    brand: "Maruti Suzuki",
    src: suzuki,
    models: ["Swift", "Baleno", "Wagon R", "Dzire", "Ertiga"],
  },
  {
    brand: "Hyundai",
    src: hyundai,
    models: ["Creta", "i20", "Venue", "Verna", "Santro"],
  },
  {
    brand: "Tata Motors",
    src: tata,
    models: ["Nexon", "Harrier", "Altroz", "Punch", "Tiago"],
  },
  {
    brand: "Mahindra",
    src: mahindra,
    models: ["XUV700", "Thar", "Scorpio", "Bolero", "XUV300"],
  },
  {
    brand: "Toyota",
    src: toyota,
    models: ["Innova Crysta", "Fortuner", "Glanza", "Urban Cruiser", "Camry"],
  },
  {
    brand: "Kia",
    src: kia,
    models: ["Seltos", "Sonet", "Carens", "Carnival"],
  },
  {
    "brand": "Honda",
    "src": honda,
    "models": ["City", "Amaze", "WR-V", "Jazz"]
  },
  {
    "brand": "Chavrolet",
    "src": chavrolet,
    "models": ["Hector", "Astor", "ZS EV", "Gloster"]
  },
  {
    "brand": "Volkswagen",
    "src": w,
    "models": ["Virtus", "Taigun", "Polo", "Vento"]
  },
  {
    "brand": "Skoda",
    "src": skoda,
    "models": ["Kushaq", "Slavia", "Octavia", "Superb"]
  },
  {
    "brand": "Renault",
    "src": renault,
    "models": ["Kwid", "Triber", "Kiger", "Duster"]
  },
  {
    "brand": "Nissan",
    "src": nissan,
    "models": ["Magnite", "Kicks"]
  },
  {
    "brand": "Ford",
    "src": ford,
    "models": ["EcoSport", "Endeavour"]
  },
  {
    "brand": "Mercedes-Benz",
    "src": benz,
    "models": ["C-Class", "E-Class", "GLA", "GLC", "GLE"]
  },
  {
    "brand": "BMW",
    "src": bmw,
    "models": ["3 Series", "X1", "X5", "5 Series"]
  },
  {
    "brand": "Audi",
    "src": audi,
    "models": ["A4", "Q3", "Q5", "A6"]
  },
  {
    "brand": "Volvo",
    "src": volvo,
    "models": ["XC40", "XC60", "S60"]
  },
  {
    "brand": "Jaguar",
    "src": jaguar,
    "models": ["XF", "F-Pace", "I-Pace"]
  },
];

const Brand = ({ onSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleBrandSelect = (type, brandName) => {
    localStorage.setItem("selectedBrand", brandName);

    onSelect(type, brandName);
  };

  const filteredBrands = brands.filter((brand) =>
    brand.brand.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      style={{
        fontFamily: "Barlow Condensed",
        height: "44rem",
        maxHeight: "90vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
      className="overflow-auto"
    >
      <h4 style={{ fontFamily: "Ballega" }} className="text-center text-3xl mb-8">
        Select the car brand
      </h4>
      <div className="relative mb-8 flex justify-center items-center">
        <input
          type="search"
          placeholder="SEARCH FOR THE BRAND"
          aria-label="Search"
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full px-4 py-4 text-center placeholder-gray font-bold text-lg border border-black rounded-lg text-sm focus:ring focus:ring-black-200 focus:outline-none"
        />
        <span className="absolute right-16 sm:right-52 lg:right-96 flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-5 h-5 text-black"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M9 16a7 7 0 100-14 7 7 0 000 14z"
            />
          </svg>
        </span>
      </div>
      <h4 style={{ fontFamily: "Ballega" }} className="text-3xl mb-8">
        Popular Brands
      </h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
        {filteredBrands.map((brand, index) => (
          <button key={index} onClick={() => handleBrandSelect("brand", brand.brand)}>
            <img src={brand.src} alt={brand.brand} loading="lazy" className="sm:w-60 sm:h-36" />
          </button>
        ))}
      </div>
      <h4 style={{ fontFamily: "Ballega" }} className="text-3xl mb-8">
        Remaining Brands
      </h4>
      <div className="grid gap-4">
        <button
          onClick={() => handleBrandSelect("brand", "Others")}
          className="flex justify-center items-center p-9 border bg-rose-200 hover:bg-rose-400"
        >
          <h4 className="text-3xl sm:text-5xl font-bold">Others</h4>
        </button>
      </div>
    </div>
  );
};

export default Brand;
